import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, withStyles, FormControl, Button } from '@material-ui/core';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Modal from '@material-ui/core/Modal';
import crossIcon from 'aurora-images/cross.svg';
import BackCloseicon from 'aurora-images/BackClose.svg';

import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import styles from './styles';
function AppendixModal(props) {
  const { classes, appendix, submitAppendix, isContractDetail, isOpen, onClose } = props;
  const [selectedAppendix, setSelectedAppendix] = useState(appendix);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  return (
    <Modal
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      open={isOpen}
      onClose={() => {
        onClose();
      }}
      style={{ overflow: 'scroll' }}
    >
      <div className={classNames(classes.modal, classes.modalpaper, classes.appendixmodal)}>
        <img src={crossIcon} alt='crossicon' className={classes.crossIconimg} onClick={onClose} aria-hidden='true' />
        <div className={classes.modaltitlehead}>
          <img
            src={BackCloseicon}
            alt='BackClose'
            className={classes.mobilebackarrow}
            onClick={onClose}
            aria-hidden='true'
          />
          <Typography variant='h6' component='h1' className={classes.Title}>
            {!isContractDetail && <FormattedMessage {...messages.add_appendix} />}
            {isContractDetail && <FormattedMessage {...messages.appendix} />}
          </Typography>
        </div>
        <FormControl className={classes.formControl}>
          <div className={classes.unitinputControl}>
            <p dir='ltr'>
              {/* <FormattedMessage
                {...messages.term_en_web}
                values={{ s: ` ${(appendix?.index ? appendix?.index : 0) + 1}` }}
              /> */}
              {'Term {s} (English)'.replace('{s}', (appendix?.index ? appendix?.index : 0) + 1)}
            </p>
            {isContractDetail ? (
              <Typography variant='subtitle1' className={classes.disabled}>
                {appendix?.appendixEn}
              </Typography>
            ) : (
              <>
                <TextareaAutosize
                  aria-label='minimum'
                  minRows={1}
                  placeholder=''
                  id='english'
                  value={selectedAppendix?.appendixEn}
                  className={!selectedAppendix?.appendixEn && isSubmitted ? classes.notValid : ''}
                  dir='ltr'
                  onChange={e => {
                    // /^[a-zA-Z0-9-@$!%=*?_+'"{}#/ \\()&±^\s]*$/
                    // if (/^[~`!@#$%^&*()_+= [\]\\{}|;':",./<>?a-zA-Z0-9-]+$/.test(e.target.value)) {
                    setSelectedAppendix({ ...selectedAppendix, appendixEn: e.target.value });
                    setError('');
                    // } else if (e.target.value === '') {
                    //   setSelectedAppendix({ ...selectedAppendix, appendixEn: '' });
                    //   setError('');
                    // } else {
                    //   setSelectedAppendix({ ...selectedAppendix, appendixEn: selectedAppendix?.appendixEn || '' });
                    //   setError('en');
                    // }
                  }}
                />
                {error === 'en' && (
                  <span style={{ color: '#D2374F' }}>
                    <FormattedMessage {...messages.only_english_characters_are_allowed} />
                  </span>
                )}
              </>
            )}
          </div>
          {isContractDetail && <hr className={classes.hr} />}
          <div className={classes.unitinputControl}>
            <p className={classes.arabicLanguage} style={{ direction: 'rtl' }}>
              {'الشرط رقم {s} ( بالعربي)'.replace('{s}', (appendix?.index ? appendix?.index : 0) + 1)}
            </p>{' '}
            {isContractDetail ? (
              <Typography variant='subtitle1' className={`${classes.disabled} ${classes.alignRight}`}>
                {/* <FormattedMessage {...{ id: appendix?.appendixAr, defaultMessage: appendix?.appendixAr }}  /> */}
                {appendix?.appendixAr}
              </Typography>
            ) : (
              <>
                <TextareaAutosize
                  aria-label='minimum'
                  minRows={1}
                  placeholder=''
                  value={selectedAppendix?.appendixAr}
                  dir='rtl'
                  className={!selectedAppendix?.appendixAr && isSubmitted ? classes.notValid : ''}
                  onChange={e => {
                    // if (/^[\u0621-\u064A\u0660-\u0669-0-9-@$!% =*?_+'" {}#()&±^-]+$/.test(e.target.value)) {
                    setSelectedAppendix({ ...selectedAppendix, appendixAr: e.target.value });
                    setError('');
                    // } else if (e.target.value === '') {
                    //   setSelectedAppendix({ ...selectedAppendix, appendixAr: '' });
                    //   setError('');
                    // } else {
                    //   setSelectedAppendix({ ...selectedAppendix, appendixAr: selectedAppendix?.appendixAr || '' });
                    //   setError('ar');
                    // }
                  }}
                />
                {error === 'ar' && (
                  <span style={{ color: '#D2374F' }}>
                    <FormattedMessage {...messages.only_arabic_characters_are_allowed} style={{ color: '#D2374F' }} />
                  </span>
                )}
              </>
            )}
          </div>
        </FormControl>
        {!isContractDetail && (
          <div className={classes.submitBtnholder}>
            <Button
              variant='contained'
              className={classNames(classes.btns, classes.submitBtn)}
              size='large'
              onClick={() => {
                (selectedAppendix?.appendixEn || selectedAppendix?.appendixAr) &&
                  submitAppendix &&
                  submitAppendix(selectedAppendix);
                setIsSubmitted(true);
              }}
            >
              <FormattedMessage {...messages.submit} />
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}
AppendixModal.propTypes = {
  classes: PropTypes.object.isRequired,
  isContractDetail: PropTypes.bool,
  submitAppendix: PropTypes.func,
  appendix: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
AppendixModal.defaultProps = {
  submitAppendix: () => {},
  isContractDetail: false,
};
export default withStyles(styles)(AppendixModal);
